var map = {
	"./CE.png": 3047,
	"./CSE.png": 1192,
	"./ECE.png": 8394,
	"./EEE.png": 2392,
	"./ME.png": 2393,
	"./aiml.png": 9902,
	"./datascience.png": 9397,
	"./logopng.png": 7581,
	"./mobileapp.png": 9944,
	"./noimage.png": 8863,
	"./webdev.png": 4732
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4504;